import gql from 'graphql-tag';

/**
 * Data of the block project-parties ("Geschäftspartner"): the four party lists with the party
 * fields the page read before (`projectFields`). Read through `Project.blocks.parties`, which
 * checks the block's read permission.
 */
export const PROJECT_PARTIES_FIELDS = gql`
  fragment projectPartiesFields on ProjectPartiesBlock {
    id
    number
    projectRightsOwners {
      _id
      number
      company
      firstname
      lastname
      city
      zip
      email
    }
    projectRightsBrokers {
      _id
      number
      company
      firstname
      lastname
      city
      zip
      email
    }
    investors {
      _id
      number
      company
      firstname
      lastname
      city
      zip
      email
    }
    investorBrokers {
      _id
      number
      company
      firstname
      lastname
      city
      zip
      email
    }
  }
`;
